import { Injectable } from '@angular/core'
import { createFrom, EventService } from '@spartacus/core'
import { CheckoutPageEvent } from './checkout-page.event'
import { NavigationEvent } from '@spartacus/storefront'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { CheckoutConfig } from '../../checkout/config'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutPageEventBuilder {

  constructor (protected eventService: EventService,
               protected activeCartService: ActiveCartService,
               protected checkoutConfig: CheckoutConfig) {
    this.init()
  }

  init () {
    this.eventService.register(CheckoutPageEvent, this.buildCheckoutPageEvent())
  }

  buildCheckoutPageEvent () {
    return this.eventService.get(NavigationEvent).pipe(
      filter(navigationEvent => /checkout\//.test(navigationEvent.context.id || '')),
      switchMap(navigation => this.activeCartService.getActive().pipe(
        filter(cart => Boolean(cart.code)),
        take(1),
        map(cart => createFrom(CheckoutPageEvent, {
          navigation,
          cart,
          step: this.checkoutConfig.checkout?.steps?.find(r => r.routeName === navigation.semanticRoute)?.step || -1
        }))
      ))
    )
  }
}
